<template>
  <div class="l-score-sum">
    <div class="l-score">
    <h3>{{right}} / {{ total }}</h3>
    <p>
      <span>正确</span>
      <span>总数</span>
    </p>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    right: [Number],
    total: [Number],
  },
}
</script>

<style lang="stylus" scoped>
.l-score-sum
  display flex
  width: 100%;
  align-items: center;
  justify-content: center;
.l-score
  display inline-flex
  flex-direction column
  h3, p
    display inline-flex
    justify-content space-between
    align-items center
  h3
    margin 0
    padding 0
    color #01FCFA
    font-size 36px
  p
    font-size 14px
    color 0
    padding 0
    margin 0
    span
      scale 0.8
</style>